<template>
    <div class="a-modal">
        <div class="popup__header">
            <span
                class="title title--sm popup__title">{{ $route.params.id ? $lang('partner.addResponsible.title') : $lang('partner.addResponsible.title2') }}</span>
        </div>
        <form class="form" @submit.prevent="submit" ref="form">
            <div class="popup__content">
                <div class="form__item form__item--inline">
                    <div class="form__inner">
                        <span class="a-filters__name">{{ $lang('partner.addResponsible.master') }}</span>
                        <el-popover v-model="errors.master_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="150"
                                    popper-class="add__error-popover"
                                    :content="$lang('partner.addResponsible.master.select')">
                            <el-select :placeholder="$lang('partner.addResponsible.master.select2')"
                                       class="a-filters__top-form"
                                       v-model="form.master_id"
                                       :disabled="!!id"
                                       required
                                       filterable
                                       slot="reference"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       :class="{ 'add__error': errors.master_id.isErrorPaint }" @focus="clearErrors">
                                <el-option v-for="item in masters"
                                           :key="item.user_id"
                                           :label="item.id + ' ' + item.user.name"
                                           :value="item.user_id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                </div>
                <div class="form__item">
                    <span class="form__label">{{ $lang('partner.addResponsible.respData') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.name.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('partner.addResponsible.name.placeholder')"
                                  class="input input--big" v-model="form.name"></el-input>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('partner.addResponsible.name.hint') }}</span>
                </div>
                <div class="form__item a-modal__big">
                    <el-popover :value="errors.phone.isError || errors.phone_md5.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.phone.message || errors.phone_md5.message">
                        <div slot="reference">
                            <input-phone-by-country v-model="form.phone"
                                                    @isValid="$event => this.isValidPhone = $event"
                                                    :fetch-country="true"
                                                    @focus="clearErrors"
                                                    :placeholder="$lang('partner.addResponsible.phone.placeholder')"
                                                    required/>
                        </div>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('partner.addResponsible.phone.hint') }}</span>
                </div>
                <div class="form__item a-modal__big">
                    <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.email.message || errors.email_md5.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('partner.addResponsible.email.placeholder')"
                                  class="input input--big"
                                  v-model="form.email"/>
                    </el-popover>
                    <span class="a-modal__hint" v-if="!this.id">{{ $lang('partner.addResponsible.email.hint') }}</span>
                </div>
                <div class="form__item a-modal__big" v-if="id">
                    <button class="btn btn--middle btn--main-bg" :disabled="disableSetPassword"
                            @click.prevent="sendNewPassword(id)">{{ $lang('partner.addResponsible.restoreButton') }}
                    </button>
                </div>
            </div>
            <div class="popup__footer">
                <button class="btn btn--middle btn--main-bg">{{ $lang('partner.addResponsible.save') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import userEdit from "../../../mixins/userEdit";
import InputPhone from "../../../components/InputPhone";
import InputPhoneByCountry from "../../../components/InputPhoneByCountry";
import validator from "../../../mixins/validator";
import Vue from "vue";

export default {
    name: "PartnerAddResponsible",
    mixins: [userEdit, validator],
    components: {InputPhone, InputPhoneByCountry},
    data: () => ({
        form: {
            name: '',
            email: '',
            phone: '',
            password: Math.random().toString(36).slice(-8),
            master_id: null,
            partner_id: window.laravel.user.id,
            id: null,
        },
        isValidPhone: true,
        rules: {
            phone: {
                validator: (rule, value, cb) => { cb() }
            },
        },
        errors: {
            name: {
                isError: false,
                message: ''
            },
            email: {
                isError: false,
                message: ''
            },
            email_md5: {
                isError: false,
                message: ''
            },
            phone: {
                isError: false,
                message: ''
            },
            phone_md5: {
                isError: false,
                message: ''
            },
            master_id: {
                isError: false,
                message: ''
            },
        },
        locale: window.laravel.locale
    }),
    computed: {
        ...mapState('auth', [
            'user'
        ]),
        ...mapState('pages', [
            'partners',
            'masters'
        ]),
        id() {
            return this.$route.params.id;
        }
    },
    mounted() {
        this.getMastersList(this.form.partner_id);
        this.form.master_id = undefined;

        if (this.$route.params.responsible) {
            this.form.email = this.$route.params.responsible.email;
            this.form.phone = this.$route.params.responsible.phone;
            this.form.name = this.$route.params.responsible.name;
            this.form.id = this.$route.params.responsible.id;
        }
    },
    created() {
        if (this.id) {
            this.getUser(this.id)
                .then((response) => {
                    this.setData(
                        'form',
                        ['id', 'name', 'email', 'phone', 'master_id', 'partner_id'],
                        response.data,
                        ['id', 'name', 'email', 'phone', 'master_id', 'partner_id']
                    );
                })
        }
    },
    methods: {
        ...mapActions('pages', [
            'getPartnersList',
            'getMastersList',
            'getAllMasters',
        ]),
        ...mapActions('user', [
            'createUser',
            'editUser',
            'getUser',
            'resetPassword',
        ]),
        submit() {
            this.rules.phone.validator = (rule, value, cb) => {
                this.isValidPhone
                    ? cb()
                    : cb(new Error(Vue.prototype.$lang('miniProfile.invalidPhone')));
            };

            this.validate(() => {
                this.$loading(this.$optionsLoading);

                if (this.id) {
                    this.edit();
                } else {
                    this.create();
                }
            }, this.form,
                true);
        },
        create() {
            this.createUser(this.form)
                .then((response) => {
                    this.$appNotify.success(Vue.prototype.$lang('partner.addResponsible.success'));
                    this.$refs.form.reset();
                    this.$router.push({name: 'partner-responsibles'});
                }).catch((error) => {
                if (error.response.data.hasOwnProperty('errors')) {
                    this.createErrors(error.response.data.errors);
                } else {
                    this.$appNotify(error.response.data.message);
                }
            }).finally(() => {
                this.$loading({}).close();
            });
        },
        edit() {
            this.editUser(this.form)
                .then((response) => {
                    this.setData(
                        'form',
                        ['name', 'email', 'phone', 'master_id', 'partner_id'],
                        response.data,
                        ['name', 'email', 'phone', 'master_id', 'partner_id']
                    );

                    this.$appNotify.success(Vue.prototype.$lang('partner.addResponsible.success2'));
                    this.$refs.form.reset();
                    this.$router.push({name: 'partner-responsibles'});
                }).catch((error) => {
                this.createErrors(error.response.data.errors);
            }).finally(() => {
                this.$loading({}).close();
            });
        },
        sendNewPassword(id) {
            if (!this.form.email && this.locale !== 'ru') {
                this.$appNotify.error(this.$lang('partner.addResponsible.sendPassword.emailRequired'));

                return this.errors.email = {
                    isError: true,
                    message: this.$lang('partner.addResponsible.sendPassword.emailRequired')
                }
            }

            this.setNewPassword(id);
        }
    }
}
</script>
